// Maps zip code prefixes (first 3 digits) to metro regions
// Falls back to nearest major metro for rural areas
const ZIP3_TO_METRO = {
  // Kansas City Metro
  '640': 'Kansas City', '641': 'Kansas City', '644': 'Kansas City', '646': 'Kansas City',
  '660': 'Kansas City', '661': 'Kansas City', '662': 'Kansas City', '664': 'Kansas City', '666': 'Kansas City',
  // KC extended / rural MO+KS that share suppliers
  '645': 'Kansas City', '647': 'Kansas City', '648': 'Kansas City',
  '663': 'Kansas City', '665': 'Kansas City', '667': 'Kansas City',
  // St. Louis
  '630': 'St. Louis', '631': 'St. Louis', '633': 'St. Louis', '620': 'St. Louis', '622': 'St. Louis',
  // Springfield MO
  '656': 'Springfield MO', '657': 'Springfield MO', '658': 'Springfield MO',
  // Columbia / Jeff City MO
  '650': 'Mid-Missouri', '651': 'Mid-Missouri', '652': 'Mid-Missouri', '653': 'Mid-Missouri',
  // Wichita KS
  '670': 'Wichita', '671': 'Wichita', '672': 'Wichita',
  // Topeka KS (664-666 already covered above under KC Metro)
  '668': 'Kansas City', '669': 'Kansas City',
  // Chicago
  '606': 'Chicago', '600': 'Chicago', '601': 'Chicago', '604': 'Chicago', '605': 'Chicago',
  '608': 'Chicago', '609': 'Chicago',
  // New York
  '100': 'New York', '101': 'New York', '102': 'New York', '103': 'New York', '104': 'New York',
  '105': 'New York', '106': 'New York', '107': 'New York', '108': 'New York', '109': 'New York',
  '110': 'New York', '111': 'New York', '112': 'New York', '113': 'New York', '114': 'New York',
  // Los Angeles
  '900': 'Los Angeles', '901': 'Los Angeles', '902': 'Los Angeles', '903': 'Los Angeles',
  '904': 'Los Angeles', '905': 'Los Angeles', '906': 'Los Angeles', '907': 'Los Angeles',
  '908': 'Los Angeles', '910': 'Los Angeles', '911': 'Los Angeles', '912': 'Los Angeles',
  '913': 'Los Angeles', '914': 'Los Angeles', '917': 'Los Angeles', '918': 'Los Angeles',
  // San Francisco / Bay Area
  '940': 'San Francisco', '941': 'San Francisco', '943': 'San Francisco', '944': 'San Francisco',
  '945': 'San Francisco', '946': 'San Francisco', '947': 'San Francisco', '948': 'San Francisco',
  '949': 'San Francisco', '950': 'San Francisco', '951': 'San Francisco',
  // Dallas / Fort Worth
  '750': 'Dallas', '751': 'Dallas', '752': 'Dallas', '753': 'Dallas',
  '760': 'Dallas', '761': 'Dallas', '762': 'Dallas',
  // Houston
  '770': 'Houston', '771': 'Houston', '772': 'Houston', '773': 'Houston', '774': 'Houston', '775': 'Houston',
  // San Antonio
  '780': 'San Antonio', '781': 'San Antonio', '782': 'San Antonio',
  // Austin
  '786': 'Austin', '787': 'Austin', '789': 'Austin',
  // Denver
  '800': 'Denver', '801': 'Denver', '802': 'Denver', '803': 'Denver', '804': 'Denver', '805': 'Denver',
  // Phoenix
  '850': 'Phoenix', '851': 'Phoenix', '852': 'Phoenix', '853': 'Phoenix',
  // Seattle
  '980': 'Seattle', '981': 'Seattle', '982': 'Seattle', '983': 'Seattle', '984': 'Seattle',
  // Portland
  '970': 'Portland', '971': 'Portland', '972': 'Portland',
  // Atlanta
  '300': 'Atlanta', '301': 'Atlanta', '302': 'Atlanta', '303': 'Atlanta', '304': 'Atlanta', '305': 'Atlanta',
  '306': 'Atlanta', '310': 'Atlanta', '311': 'Atlanta', '312': 'Atlanta',
  // Miami / South Florida
  '330': 'Miami', '331': 'Miami', '332': 'Miami', '333': 'Miami', '334': 'Miami',
  // Tampa
  '335': 'Tampa', '336': 'Tampa', '337': 'Tampa', '338': 'Tampa',
  // Orlando
  '327': 'Orlando', '328': 'Orlando', '347': 'Orlando',
  // Nashville
  '370': 'Nashville', '371': 'Nashville', '372': 'Nashville',
  // Minneapolis
  '550': 'Minneapolis', '551': 'Minneapolis', '553': 'Minneapolis', '554': 'Minneapolis', '555': 'Minneapolis',
  // Detroit
  '480': 'Detroit', '481': 'Detroit', '482': 'Detroit', '483': 'Detroit', '484': 'Detroit',
  // Philadelphia
  '190': 'Philadelphia', '191': 'Philadelphia', '193': 'Philadelphia', '194': 'Philadelphia',
  // Boston
  '021': 'Boston', '022': 'Boston', '023': 'Boston', '024': 'Boston', '020': 'Boston',
  // Washington DC
  '200': 'Washington DC', '201': 'Washington DC', '202': 'Washington DC', '203': 'Washington DC',
  '204': 'Washington DC', '205': 'Washington DC', '206': 'Washington DC', '207': 'Washington DC',
  '208': 'Washington DC', '209': 'Washington DC', '220': 'Washington DC', '221': 'Washington DC',
  '222': 'Washington DC', '223': 'Washington DC',
  // Las Vegas
  '889': 'Las Vegas', '890': 'Las Vegas', '891': 'Las Vegas',
  // San Diego
  '919': 'San Diego', '920': 'San Diego', '921': 'San Diego',
  // Charlotte
  '280': 'Charlotte', '281': 'Charlotte', '282': 'Charlotte',
  // Indianapolis
  '460': 'Indianapolis', '461': 'Indianapolis', '462': 'Indianapolis',
  // Columbus OH
  '430': 'Columbus OH', '431': 'Columbus OH', '432': 'Columbus OH',
  // Pittsburgh
  '150': 'Pittsburgh', '151': 'Pittsburgh', '152': 'Pittsburgh',
  // Cincinnati
  '450': 'Cincinnati', '451': 'Cincinnati', '452': 'Cincinnati',
  // Cleveland
  '440': 'Cleveland', '441': 'Cleveland', '442': 'Cleveland', '443': 'Cleveland', '444': 'Cleveland',
  // New Orleans
  '700': 'New Orleans', '701': 'New Orleans',
  // Salt Lake City
  '840': 'Salt Lake City', '841': 'Salt Lake City',
  // Omaha
  '680': 'Omaha', '681': 'Omaha',
  // Des Moines
  '500': 'Des Moines', '501': 'Des Moines', '503': 'Des Moines',
};

// State abbreviation to fallback metro (largest city in state)
const STATE_FALLBACKS = {
  'AL': 'Birmingham', 'AK': 'Anchorage', 'AZ': 'Phoenix', 'AR': 'Little Rock',
  'CA': 'Los Angeles', 'CO': 'Denver', 'CT': 'Hartford', 'DE': 'Wilmington',
  'FL': 'Miami', 'GA': 'Atlanta', 'HI': 'Honolulu', 'ID': 'Boise',
  'IL': 'Chicago', 'IN': 'Indianapolis', 'IA': 'Des Moines', 'KS': 'Kansas City',
  'KY': 'Louisville', 'LA': 'New Orleans', 'ME': 'Portland ME', 'MD': 'Washington DC',
  'MA': 'Boston', 'MI': 'Detroit', 'MN': 'Minneapolis', 'MS': 'Jackson',
  'MO': 'Kansas City', 'MT': 'Billings', 'NE': 'Omaha', 'NV': 'Las Vegas',
  'NH': 'Manchester', 'NJ': 'New York', 'NM': 'Albuquerque', 'NY': 'New York',
  'NC': 'Charlotte', 'ND': 'Fargo', 'OH': 'Columbus OH', 'OK': 'Oklahoma City',
  'OR': 'Portland', 'PA': 'Philadelphia', 'RI': 'Providence', 'SC': 'Charleston',
  'SD': 'Sioux Falls', 'TN': 'Nashville', 'TX': 'Dallas', 'UT': 'Salt Lake City',
  'VT': 'Burlington', 'VA': 'Washington DC', 'WA': 'Seattle', 'WV': 'Charleston WV',
  'WI': 'Milwaukee', 'WY': 'Cheyenne', 'DC': 'Washington DC',
};

/**
 * Convert a zip code to a metro region name.
 * Uses 3-digit prefix mapping, falls back to state-level metro.
 * @param {string} zip - 5-digit zip code
 * @param {string} [state] - Optional 2-letter state code for fallback
 * @returns {string} Metro region name
 */
export function getRegionFromZip(zip, state) {
  if (!zip || zip.length < 3) return state ? (STATE_FALLBACKS[state.toUpperCase()] || state) : 'Unknown';
  const prefix = zip.slice(0, 3);
  if (ZIP3_TO_METRO[prefix]) return ZIP3_TO_METRO[prefix];
  // Fallback to state
  if (state) return STATE_FALLBACKS[state.toUpperCase()] || state;
  return 'Unknown';
}
